import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfettiAnimateComponent } from './components';
import { AnimationManagerService } from './services';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { OverlayModule } from '@angular/cdk/overlay';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';


@NgModule({
  imports: [
    CommonModule,
    SvgIconsModule,
    OverlayModule,
    LottieComponent,
  ],
  declarations: [ConfettiAnimateComponent],
  providers: [
    AnimationManagerService,
    provideLottieOptions({
      player: () => player,
    })
  ]
})
export class AnimationManagerModule {}
